// Check for Horizontal Tabs sections
const horizontalTabSections = document.querySelectorAll('.horizontal-tabs');
if (horizontalTabSections) {
  horizontalTabSections.forEach((horizontalTabSection) => {
    const horizontalTabs = horizontalTabSection.querySelectorAll('.horizontal-tab');
    horizontalTabs.forEach((horizontalTab) => {
      horizontalTab.addEventListener('click', () => {
        // Remove active class from current tab
        const activeHorizontalTab = horizontalTabSection.querySelector('.horizontal-tab--active');
        activeHorizontalTab.classList.remove('horizontal-tab--active');
        // Add class to new active tab
        horizontalTab.classList.add('horizontal-tab--active');
      });
    });
  });
}

